// =============================================================================
// CONFIG — read once from window.teeinblue injected by theme.liquid
// =============================================================================

const previewModalTitle =
  window.teeinblue.prdPagePopUpHeader1 ||
  'Please check the preview carefully';
const previewModalContent =
  window.teeinblue.prdPagePopUpWarningContent ||
  'Make sure the customization is correct to receive your item faster';
const previewButtonText =
  window.teeinblue.previewButtonText || 'Preview Your Personalization';

// Spinner SVG reused by reset/confirm buttons (defined once, no duplication)
const SPINNER_SVG =
  '<span class="tee-spinner tee-spinner--sm">' +
  '<svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm">' +
  '<g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path>' +
  '<animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform>' +
  '</g></svg></span>';

// =============================================================================
// HELPERS
// =============================================================================

/**
 * Returns the height of the sticky gallery bar (used for scroll offset math).
 */
function getStickyGalleryHeight() {
  const sticky = document.querySelector(
    '.gallery--sticky:not(.gallery--sticky--hide) .tee-gallery-content'
  );
  if (sticky) return sticky.offsetHeight || 0;
  const base = document.querySelector('.tee-gallery-content');
  return base ? base.offsetHeight * 0.65 : 0;
}

/**
 * Inserts the standard preview-modal warning block before the dialog content.
 * Returns early if the target is missing or the notice is already there.
 */
function insertPreviewModalNotice() {
  const target = document.querySelector('.tee-dialog-gallery .tee-dcontent');
  if (!target || target.previousElementSibling?.classList.contains('modal_preview--modify_notice')) return;
  target.insertAdjacentHTML(
    'beforebegin',
    `<div class="modal_preview--modify_notice">
      <p class="modal_preview--title">${previewModalTitle}</p>
      <p class="modal_preview--notice_content">${previewModalContent}</p>
    </div>`
  );
}

// =============================================================================
// FEATURE: Preview modal — cart icon + warning notice
// =============================================================================

function addCartIconToPreviewBtn() {
  const btn = document.querySelector('#preview-teeAtcButton');
  if (!btn || btn.querySelector('.pfh-preview-atc-icon')) return;

  const icon =
    '<span class="pfh-preview-atc-icon" aria-hidden="true">' +
    '<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">' +
    '<path d="M1.2 2.2H3.01c.25 0 .37 0 .47.05.09.04.16.1.21.18.06.09.08.21.11.46l.47 3.31M20.92 12.5l-.43 1.6c-.18.92-.27 1.38-.5 1.73-.21.31-.5.55-.84.7-.39.17-.86.17-1.8.17H8.79c-.99 0-1.49 0-1.88-.18-.35-.16-.65-.42-.85-.75-.23-.37-.29-.86-.43-1.84L4.27 6.2M4.27 6.2H11" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<circle cx="8.97" cy="21.42" r="1.08" fill="#ffffff" stroke="#ffffff" stroke-width="1.8"/>' +
    '<circle cx="17.53" cy="21.42" r="1.08" fill="#ffffff" stroke="#ffffff" stroke-width="1.8"/>' +
    '<path d="M18.4 3.77v3.66M16.57 5.6h3.66" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<circle cx="18.4" cy="5.6" r="5" stroke="#ffffff" stroke-width="1.2"/>' +
    '</svg></span>';

  const textEl = btn.querySelector('.tee-btn__text');
  if (textEl) textEl.insertAdjacentHTML('beforebegin', icon);
  else btn.insertAdjacentHTML('afterbegin', icon);
}

function addTopContentToPreviewModal() {
  document.querySelectorAll('.tee-btn--preview').forEach((button) => {
    button.addEventListener('click', () => {
      addCartIconToPreviewBtn();
      insertPreviewModalNotice();
    });
  });
}

// =============================================================================
// FEATURE: Customization reset modal
// =============================================================================

function checkCustomizationModal() {
  const hasCustomization = window.teeinblue.hasCustomization(
    window.teeinblueCampaign?.productId || 0
  );
  const modal = document.getElementById('reset_tib_customizations');
  if (!modal || !hasCustomization) return;

  modal.style.display = 'block';

  modal.querySelectorAll('[data-close-modal]').forEach((btn) => {
    btn.addEventListener('click', () => (modal.style.display = 'none'));
  });

  modal.querySelectorAll('[data-reset-modal]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.disabled = true;
      btn.classList.add('is-loading');
      window.teeinblue.resetCustomization(window.teeinblueCampaign.productId);
      modal.style.display = 'none';
    });
  });

  modal.querySelectorAll('[data-confirm-reset]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.disabled = true;
      btn.classList.add('is-loading');
      window.teeinblue.refillCustomization(window.teeinblueCampaign.productId);
      setTimeout(() => (modal.style.display = 'none'), 500);
    });
  });
}

// =============================================================================
// FEATURE: Sticky preview button (mobile)
// =============================================================================

function createPreviewBtn() {
  const wrapper = document.querySelector('.tee-form-wrapper');
  if (!wrapper) return;
  wrapper.insertAdjacentHTML(
    'beforebegin',
    `<div class="show-mobile-only-sticky-button pfh-customily-preview-button">
      <button type="button" class="customily-preview-button ld-over-inverse pfh-clone-preview-btn"
        data-label="Add to cart" id="customily-preview-button">
        <div class="ld ld-cycle ld-ring"></div>${previewButtonText}
      </button>
    </div>`
  );
}

function btnPreviewOnScroll() {
  const stickyBtn = document.querySelector('.pfh-clone-preview-btn');
  if (!stickyBtn) return;

  const stickyPreviewBtns = document.querySelectorAll('.pfh-customily-preview-button');
  stickyPreviewBtns.forEach((el) => {
    el.style.opacity = '1';
    el.style.visibility = 'visible';
  });
  stickyBtn.parentElement.style.backgroundColor = '#fff';
  stickyBtn.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
  stickyBtn.style.setProperty('border-color', 'var(--core-color-primary)', 'important');
}

function triggerClickPreviewBtn() {
  const stickyPreviewBtn = document.querySelector('.pfh-customily-preview-button');
  const previewBtn = document.querySelector('.tee-form-action .tee-btn--preview');
  if (!stickyPreviewBtn || !previewBtn) return;

  stickyPreviewBtn.addEventListener('click', () => {
    const confirmedInput = document.querySelector('input[name="confirmed"]');
    previewBtn.click();

    if (confirmedInput && !confirmedInput.checked) {
      confirmedInput.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    setTimeout(() => {
      addCartIconToPreviewBtn();
      insertPreviewModalNotice();
    }, 50);
  });
}

// =============================================================================
// FEATURE: Replace product description with TIB description
// =============================================================================

function replaceDescContent() {
  if (!window.TIBOverrideDesc) return;
  setTimeout(() => {
    const teeDesc = document.querySelector('.tee-description__content');
    const targetRte = document.querySelector('.product-tabs__panel[tabindex="0"] .rte');
    if (teeDesc && targetRte) targetRte.innerHTML = teeDesc.innerHTML;
  }, 300);
}

// =============================================================================
// FEATURE: KiwiSizing chart placement
// Uses MutationObserver (replaces setInterval polling — no periodic main-thread cost)
// =============================================================================

function needsSpecialUidSizeChartPlacement() {
  const productFormInitEl = document.querySelector('.product_form_options');
  if (!productFormInitEl) return false;

  try {
    const productInfo = JSON.parse(productFormInitEl.getAttribute('data-product') || '{}');
    const productTags = Array.isArray(productInfo.tags) ? productInfo.tags : [];
    const coupleTags = String(window.__SIZE_CHARTS_CFG__?.coupleTags || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
    return productTags.includes('Bulk_size')
      && coupleTags.some((tag) => productTags.includes(tag));
  } catch (_) {
    return false;
  }
}

function checkKiwiSizingChart() {
  try {
    const kiwiLink = document.querySelector('#KiwiSizingChart .ks-chart-modal-link');
    const sizeOptionEl = document.querySelector('.tee-option--size .tee-option__title');
    if (!kiwiLink || !sizeOptionEl) return;

    // Detect products that need special placement (before ATC form)
    let needSpecialPlacing = false;
    const productFormInitEl = document.querySelector('.product_form_options');
    if (productFormInitEl) {
      try {
        const productInfo = JSON.parse(productFormInitEl.getAttribute('data-product') || '{}');
        const needCheckTags = ['Bulk_size', 'couple beach shorts'];
        needSpecialPlacing = needCheckTags.some((tag) => (productInfo.tags || []).includes(tag));
      } catch (_) {}
    }

    if (needSpecialPlacing) {
      const atcForm = document.querySelector('form[action="/cart/add"]');
      if (atcForm) {
        const clone = kiwiLink.cloneNode(true);
        atcForm.insertBefore(clone, atcForm.firstChild);
        clone.addEventListener('click', () => kiwiLink.click());
      }
    } else {
      if (sizeOptionEl.querySelector('.ks-chart-modal-link')) return;
      const clone = kiwiLink.cloneNode(true);
      sizeOptionEl.appendChild(clone);
      clone.addEventListener('click', () => kiwiLink.click());
    }
  } catch (err) {
    console.error('[TIB] checkKiwiSizingChart:', err);
  }
}

/**
 * Waits for #KiwiSizingChart to appear in DOM using MutationObserver.
 * No setInterval polling → zero periodic main-thread cost.
 */
function watchForKiwiSizingChart() {
  if (document.querySelector('#KiwiSizingChart .ks-chart-modal-link')) {
    checkKiwiSizingChart();
    return;
  }
  const observer = new MutationObserver(() => {
    if (document.querySelector('#KiwiSizingChart .ks-chart-modal-link')) {
      observer.disconnect();
      checkKiwiSizingChart();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function bindKiwiOnRadioChange() {
  document.querySelectorAll('.tee-available-products .tee-radio').forEach((radio) => {
    radio.addEventListener('click', () => setTimeout(checkKiwiSizingChart, 200));
  });
}

const UID_SIZE_CHART_TARGETS = [
  '#tee-artwork-form .tee-option--size .tee-option__title',
  '.uid-app__size-chart-mount'
];
const UID_SPECIAL_SIZE_CHART_TARGETS = [
  '.swatch_options',
  '.tee-variants'
];
const UID_SPECIAL_SIZE_CHART_WRAPPER_ID = 'uid-app__special-size-chart-wrapper';
const UID_SPECIAL_SIZE_CHART_MOUNT_ID = 'uid-app__special-size-chart-mount';
let uidSizeChartTrigger = null;
let uidSizeChartPlacementTimers = [];

function getUidSizeChartTrigger() {
  const liveTrigger = document.getElementById('uid-app__size-chart-trigger');
  if (liveTrigger) uidSizeChartTrigger = liveTrigger;
  return uidSizeChartTrigger;
}

function getSpecialUidSizeChartMount() {
  const swatchOptions = document.querySelector('.swatch_options');
  const teeVariants = document.querySelector('.tee-variants');
  const placementTarget = teeVariants || swatchOptions;
  if (!placementTarget) return null;

  let wrapper = document.getElementById(UID_SPECIAL_SIZE_CHART_WRAPPER_ID);
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.id = UID_SPECIAL_SIZE_CHART_WRAPPER_ID;
    wrapper.className = 'swatch';
    wrapper.style.setProperty('display', 'block', 'important');

    const optionTitle = document.createElement('div');
    optionTitle.id = UID_SPECIAL_SIZE_CHART_MOUNT_ID;
    optionTitle.className = 'option_title';
    optionTitle.appendChild(document.createTextNode('Size'));

    wrapper.appendChild(optionTitle);
  }

  if (teeVariants) {
    if (wrapper.parentElement !== teeVariants) {
      teeVariants.appendChild(wrapper);
    }
  } else if (swatchOptions) {
    if (wrapper.parentElement !== swatchOptions || swatchOptions.lastElementChild !== wrapper) {
      swatchOptions.append(wrapper);
    }
  }

  return wrapper.querySelector(`#${UID_SPECIAL_SIZE_CHART_MOUNT_ID}`);
}

function placeUidSizeChart() {
  const trigger = getUidSizeChartTrigger();
  if (!trigger) return;

  const useSpecialTarget = needsSpecialUidSizeChartPlacement()
    && UID_SPECIAL_SIZE_CHART_TARGETS.some((selector) => document.querySelector(selector));
  const specialMount = useSpecialTarget ? getSpecialUidSizeChartMount() : null;
  // Special-tag products append the wrapper below swatch options, or prepend it
  // to the TIB customize form when swatch options are unavailable.
  const targetSelector = useSpecialTarget
    ? `#${UID_SPECIAL_SIZE_CHART_MOUNT_ID}`
    : UID_SIZE_CHART_TARGETS.find((selector) => document.querySelector(selector));
  if (!targetSelector || (useSpecialTarget && !specialMount)) return;

  const target = document.querySelector(targetSelector);
  if (!target) return;

  const isPending = trigger.classList.contains('uid-app__size-chart-trigger--pending');

  // If already initialized and placed in this specific best target, do nothing.
  if (trigger.parentElement === target && !isPending) {
    return;
  }

  // TeeInBlue replaces its option DOM on variant changes. Restore the cached
  // trigger to the live DOM first so the UID app can find and initialize it.
  if (!trigger.isConnected) {
    target.appendChild(trigger);
  }

  // Let the UID app own the final placement and bind its click behavior.
  document.dispatchEvent(new CustomEvent('uid-app:size-chart:place', {
    detail: {
      anchorSelector: targetSelector,
      method: 'append',
    },
  }));
}

function scheduleUidSizeChartPlacement() {
  uidSizeChartPlacementTimers.forEach((timerId) => clearTimeout(timerId));
  uidSizeChartPlacementTimers = [];

  requestAnimationFrame(() => {
    requestAnimationFrame(placeUidSizeChart);
  });

  [50, 150, 300].forEach((delay) => {
    uidSizeChartPlacementTimers.push(setTimeout(placeUidSizeChart, delay));
  });
}

function watchForUidSizeChart() {
  const targetSelectors = needsSpecialUidSizeChartPlacement()
    ? [...UID_SPECIAL_SIZE_CHART_TARGETS, ...UID_SIZE_CHART_TARGETS]
    : UID_SIZE_CHART_TARGETS;
  const selectorString = targetSelectors.join(', ');
  if (document.querySelector(selectorString) && getUidSizeChartTrigger()) {
    scheduleUidSizeChartPlacement();
    return;
  }
  const observer = new MutationObserver(() => {
    if (document.querySelector(selectorString) && getUidSizeChartTrigger()) {
      observer.disconnect();
      scheduleUidSizeChartPlacement();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}


// =============================================================================
// FEATURE: Reference products placement (before TIB artwork form)
// =============================================================================

function moveReferenceProductsBeforeTIB() {
  const referenceProducts = document.querySelector('.reference__products--wrapper');
  const teeArtworkForm = document.querySelector('#tee-artwork-form');
  if (referenceProducts && teeArtworkForm) teeArtworkForm.before(referenceProducts);
}

// =============================================================================
// FEATURE: Upsell mount + ATC transform
// =============================================================================

function buildUpsellMount(anchorSelector) {
  const anchor = document.querySelector(anchorSelector);
  const mount = document.getElementById('upsell-app-mount');
  if (anchor && mount) anchor.after(mount);
  document.dispatchEvent(new CustomEvent('upsell-request-render'));
}

function setupTransformBeforeAddToCart() {
  window.teeinblue.transformBeforeAddToCart = (input) =>
    new Promise((resolve) => {
      const variantId = input.id;
      const randomPart = crypto.randomUUID
        ? crypto.randomUUID().replace(/-/g, '')
        : Math.random().toString(36).substring(2, 18);

      const mergedProperties = {
        ...(input.properties || {}),
        _cart_item_key: `${variantId}:${randomPart}`,
      };

      const priorityPrefixes = ['_customization_', '_tib_design_link'];
      const prioritized = {};
      const others = {};

      for (const key in mergedProperties) {
        if (priorityPrefixes.some((p) => key.startsWith(p))) prioritized[key] = mergedProperties[key];
        else others[key] = mergedProperties[key];
      }

      input.properties = { ...prioritized, ...others };

      // Không add upsell khi update cart item bằng edit design (cart drawer)
      const isEditMode = !!document.querySelector('.tee-edit-popup');
      if (isEditMode) {
          resolve([input]); 
          return;
      }
      const upsell = window.__UPSELL__?.getSelection?.();
      const upsellItems = (upsell?.items ?? [])
        .filter((x) => x.variantId && Number(x.quantity) > 0)
        .map((x) => ({
          id: x.variantId,
          quantity: Number(x.quantity) || 1,
          properties: {
            _upsell_level: 'level0',
            _parent_variant_id: variantId,
          },
        }));

      resolve([...upsellItems, input]);
    });
}

// =============================================================================
// FEATURE: Scroll to invalid field on mobile (INP-safe: click capture, guarded)
// =============================================================================

const INVALID_CLASS = 'tee-field--invalid';
const CUSTOM_INVALID_CLASS = 'tee-field--invalid-custom';
const TIB_FORM_SELECTOR = '.tee-customization-form';
const CHECK_DELAY = 50;

function scrollToInvalidField(el) {
  if (!el) return;
  const rect = el.getBoundingClientRect();
  const baseOffset = window.teeinblue.requiredScrollOffset ?? -50;
  const galleryHeight = getStickyGalleryHeight();
  window.scroll({
    top: rect.top + window.pageYOffset + baseOffset - galleryHeight,
    left: 0,
    behavior: 'smooth',
  });
}

function checkAndScrollInvalid() {
  if (document.body.classList.contains('vm--block-scroll')) return;
  const container = document.querySelector(TIB_FORM_SELECTOR) || document.body;
  const invalidEls = Array.from(
    container.querySelectorAll(`.${INVALID_CLASS}, .${CUSTOM_INVALID_CLASS}`)
  );
  if (!invalidEls.length) return;

  invalidEls.forEach((el) => {
    if (el.classList.contains(INVALID_CLASS)) {
      el.classList.add(CUSTOM_INVALID_CLASS);
      el.classList.remove(INVALID_CLASS);
    }
  });

  invalidEls.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
  setTimeout(() => scrollToInvalidField(invalidEls[0]), window.scroll_timeout ?? 500);
}

function setupScrollToInvalidOnMobile() {
  if (window.innerWidth >= 750) return;
  document.addEventListener(
    'click',
    (e) => {
      if (!e.target.closest('.tee-btn--atc,.tee-btn--preview,.customily-preview-button')) return;
      setTimeout(checkAndScrollInvalid, CHECK_DELAY);
    },
    true
  );
}

// =============================================================================
// FEATURE: BMSM per-unit price injection
// Trigger: Shopify option name contains "Buy More Save More" (case-insensitive)
// =============================================================================

const BMSM_OPTION_MARKER = 'buy more save more';
// Leading qty + unit: 1PC, 2 PCS, 2PACK, 3 ITEMS, 2 PAIR - 10% OFF, ...
const BMSM_QTY_RE = /^(\d+)\s*(pc|pack|item|pair)s?\b/i;

let bmsmConfig;
let bmsmVariantId;
const bmsmObservers = new WeakMap();

function isBmsmOptionName(name) {
  return String(name || '').toLowerCase().includes(BMSM_OPTION_MARKER);
}

function parseBmsmOption(rawValue) {
  const match = String(rawValue).trim().match(BMSM_QTY_RE);
  if (!match) return null;

  const qty = parseInt(match[1], 10);
  if (qty < 1) return null;

  const singular = match[2].toLowerCase();
  const qtyLabel = qty === 1 ? `1 ${singular}` : `${qty} ${singular}s`;

  return {
    qty,
    qtyLabel: qtyLabel.toUpperCase(),
    unitSuffix: `/${singular}`,
  };
}

function getBmsmPriceCents(price) {
  const value = Number(price);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return String(price).includes('.') ? Math.round(value * 100) : Math.round(value);
}

function getVariantOptionValues(variant, optionCount) {
  return Array.from(
    { length: optionCount },
    (_, index) => variant[`option${index + 1}`] ?? variant.options?.[index]
  );
}

function getBmsmConfig() {
  if (bmsmConfig !== undefined) return bmsmConfig;

  bmsmConfig = null;
  const el = document.querySelector('.product_form_options[data-product]');
  if (!el) return null;

  const raw = el.getAttribute('data-product') || '';
  if (!raw) return null;

  let product;
  try {
    product = JSON.parse(raw);
  } catch (_) {
    return null;
  }

  const optionNames = (product.options || []).map((opt) =>
    typeof opt === 'string' ? opt : opt?.name
  );
  const optionIndex = optionNames.findIndex(isBmsmOptionName);
  if (optionIndex < 0) return null;

  const optionKey = `option${optionIndex + 1}`;
  const variantsByOptions = new Map();
  const optionsByVariantId = new Map();

  for (const variant of product.variants || []) {
    const rawValue = variant[optionKey];
    if (!rawValue) continue;

    const parsed = parseBmsmOption(rawValue);
    if (!parsed) continue;

    const totalCents = getBmsmPriceCents(variant.price);
    if (totalCents <= 0) continue;

    const optionValues = getVariantOptionValues(variant, optionNames.length);
    if (optionValues.some((value) => value == null)) continue;

    const entry = {
      unitCents: Math.floor(totalCents / parsed.qty),
      qtyLabel: parsed.qtyLabel,
      unitSuffix: parsed.unitSuffix,
    };
    variantsByOptions.set(JSON.stringify(optionValues), entry);
    optionsByVariantId.set(String(variant.id), optionValues);
  }

  if (variantsByOptions.size === 0) return null;

  bmsmConfig = {
    productEl: el,
    optionIndex,
    optionCount: optionNames.length,
    variantsByOptions,
    optionsByVariantId,
    moneyFormat: el.getAttribute('data-money-format') || '${{amount}}',
  };
  return bmsmConfig;
}

function getBmsmOptionElements() {
  return [...document.querySelectorAll(
    '#tee-artwork-form .tee-option, .tee-variants .tee-option'
  )];
}

function getCurrentBmsmOptionValues(config) {
  const selectedVariantId =
    bmsmVariantId || config.productEl.querySelector('[name="id"]')?.value;
  const optionValues = config.optionsByVariantId.get(String(selectedVariantId || ''));

  // A one-option product does not need a selected variant as context because
  // the BMSM value itself uniquely identifies every variant.
  if (!optionValues && config.optionCount === 1) return [null];

  return optionValues || null;
}

function getBmsmEntry(config, currentOptions, bmsmValue) {
  if (!currentOptions) return null;

  const targetOptions = [...currentOptions];
  targetOptions[config.optionIndex] = bmsmValue;
  return config.variantsByOptions.get(JSON.stringify(targetOptions)) || null;
}

function formatBmsmUnitPrice(cents, moneyFormat, unitSuffix) {
  const formatted =
    typeof window.Shopify?.formatMoney === 'function'
      ? window.Shopify.formatMoney(cents, moneyFormat)
      : `$${(cents / 100).toFixed(2)}`;
  return `${formatted}${unitSuffix}`;
}

function ensureBmsmObserver(optionEl) {
  if (bmsmObservers.has(optionEl)) return;

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(injectBmsmUnitPrices, 50);
  });

  observer.observe(optionEl, { childList: true, subtree: true });
  bmsmObservers.set(optionEl, observer);
}

function injectBmsmUnitPrices() {
  const config = getBmsmConfig();
  if (!config) return;

  const optionEl = getBmsmOptionElements().find(
    (el) => isBmsmOptionName(el.querySelector('.tee-option__title')?.textContent)
  );
  if (!optionEl) return;

  ensureBmsmObserver(optionEl);
  const currentOptions = getCurrentBmsmOptionValues(config);
  if (!currentOptions) return;

  for (const radio of optionEl.querySelectorAll('.tee-radio')) {
    const input = radio.querySelector('input[type="radio"]');
    const label = radio.querySelector('.tee-radio-label');
    if (!input || !label) continue;

    const entry = getBmsmEntry(config, currentOptions, input.value);
    if (!entry) continue;

    let qtySpan = label.querySelector('.bmsm-qty');
    let priceSpan = label.querySelector('.bmsm-unit-price');
    if (!qtySpan || !priceSpan) {
      label.replaceChildren();
      qtySpan = document.createElement('span');
      qtySpan.className = 'bmsm-qty';
      priceSpan = document.createElement('span');
      priceSpan.className = 'bmsm-unit-price';
      label.append(qtySpan, priceSpan);
    }

    const unitPrice = formatBmsmUnitPrice(
      entry.unitCents,
      config.moneyFormat,
      entry.unitSuffix
    );
    if (qtySpan.textContent !== entry.qtyLabel) qtySpan.textContent = entry.qtyLabel;
    if (priceSpan.textContent !== unitPrice) priceSpan.textContent = unitPrice;
    label.dataset.bmsmInjected = '1';
  }
}

// =============================================================================
// FEATURE: Hide single / irrelevant preview options
// =============================================================================

function hideSinglePreviewOptions(root = document) {
  root.querySelectorAll('.tee-variants .tee-option').forEach((option) => {
    const radios = option.querySelectorAll('.tee-radio');
    option.style.display = '';
    radios.forEach((r) => (r.style.display = ''));
    if (!radios.length) return;

    if (radios.length === 1) {
      const text = radios[0].querySelector('span')?.textContent?.trim();
      if (text === 'As Preview' || text === 'As Described') option.style.display = 'none';
      return;
    }

    radios.forEach((r) => {
      const text = r.querySelector('span')?.textContent?.trim();
      if (text === 'As Preview' || text === 'As Described') r.style.display = 'none';
    });
  });
}

// =============================================================================
// ONE-TIME INIT — style injection runs immediately (not inside event handler)
// Injecting CSS inside teeinblue-event-component-injected caused a style
// recalculation on every event fire. Moving it here runs it once at parse time.
// =============================================================================

(function injectInvalidCustomStyle() {
  const STYLE_ID = 'tee-invalid-custom-style';
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `.tee-field--invalid-custom .tee-required-message { display: inline-block; }`;
  document.head.appendChild(style);
})();

// =============================================================================
// EVENT: DOMContentLoaded
// =============================================================================

document.addEventListener('DOMContentLoaded', () => {
  // Move #loading_element before the Shopify product form
  const loadingEl = document.querySelector('#loading_element');
  const productForm = document.querySelector('form.shopify-product-form');
  if (loadingEl && productForm) productForm.before(loadingEl);

  // Fallback for UID Size Chart (in case teeinblue-event-component-injected does not run)
  watchForUidSizeChart();
});

// =============================================================================
// EVENT: teeinblue-event-component-injected — SINGLE consolidated listener
// (Previously 8 separate listeners; merged to reduce callback overhead per event)
// =============================================================================

document.addEventListener('teeinblue-event-component-injected', () => {
  // Price element
  const priceEl = document.querySelector('.tee-product-price');
  const priceTarget = document.querySelector('.product-block--price');
  if (priceEl && priceTarget) priceTarget.prepend(priceEl);

  // Preview modal
  addTopContentToPreviewModal();
  checkCustomizationModal();

  // Mobile sticky preview button
  createPreviewBtn();
  btnPreviewOnScroll();
  triggerClickPreviewBtn();

  // TIB description override
  replaceDescContent();

  // KiwiSizing chart (MutationObserver — no setInterval)
  watchForKiwiSizingChart();
  bindKiwiOnRadioChange();

  // Size chart (uid-app)
  scheduleUidSizeChartPlacement();


  // Reference products placement
  moveReferenceProductsBeforeTIB();

  // Upsell
  buildUpsellMount('#teeFormInputs');
  setupTransformBeforeAddToCart();

  // Scroll to invalid field (mobile only)
  setupScrollToInvalidOnMobile();

  // Hide irrelevant preview options
  hideSinglePreviewOptions();

  // BMSM per-unit price labels
  injectBmsmUnitPrices();
});

// =============================================================================
// EVENT: teeinblue-event-variant-changed — SINGLE consolidated listener
// (Previously 3 separate listeners)
// =============================================================================

document.addEventListener('teeinblue-event-variant-changed', (event) => {
  if (event.detail?.variantId) bmsmVariantId = String(event.detail.variantId);
  replaceDescContent();
  checkKiwiSizingChart();
  scheduleUidSizeChartPlacement();
  setTimeout(() => {
    hideSinglePreviewOptions();
    injectBmsmUnitPrices();
  }, 50);
});

// =============================================================================
// EVENT: teeinblue-event-after-cart-added
// =============================================================================

document.addEventListener('teeinblue-event-after-cart-added', () => {
  hideSinglePreviewOptions();
  document.dispatchEvent(
    new CustomEvent('spf:cart:add:success', {
      detail: { source: 'teeinblue', originalEventType: 'teeinblue-event-after-cart-added' },
    })
  );
});

// =============================================================================
// IIFE: TIB image retry — overlay spinner while broken TIB images reload
// Fires on global 'error' capture; retries up to MAX times with backoff.
// =============================================================================

(function () {
  var MAX = 15;
  var DELAY = 1000;
  var SVG_URL = 'https://cdn.teeinblue.com/common/loading.svg';

  function sleep(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }

  function probeDecode(src) {
    return new Promise(function (resolve) {
      var p = new Image();
      p.onload = function () { resolve(true); };
      p.onerror = function () { resolve(false); };
      p.src = src;
    });
  }

  function buildUrl(base, n) {
    try {
      var u = new URL(base, document.baseURI);
      u.searchParams.set('retry', String(n));
      return u.href;
    } catch (_) {
      var q = base.indexOf('?') >= 0 ? '&' : '?';
      return base + q + 'retry=' + n + '&t=' + Date.now();
    }
  }

  function wrap(img) {
    var r = img.parentElement;
    if (r && r.classList.contains('tib-img-retry-root')) return r;
    r = document.createElement('span');
    r.className = 'tib-img-retry-root';
    img.parentNode.insertBefore(r, img);
    r.appendChild(img);
    return r;
  }

  function overlayOn(root) {
    var ov = root.querySelector('.tib-img-retry-overlay');
    if (ov) { ov.hidden = false; return; }
    ov = document.createElement('span');
    ov.className = 'tib-img-retry-overlay';
    ov.setAttribute('aria-hidden', 'true');
    var s = document.createElement('img');
    s.src = SVG_URL;
    s.alt = '';
    s.className = 'tib-img-retry-spinner';
    s.setAttribute('data-tee-retry-spinner', '1');
    ov.appendChild(s);
    root.appendChild(ov);
  }

  function overlayOff(img) {
    var r = img.parentElement;
    if (!r || !r.classList.contains('tib-img-retry-root')) return;
    var ov = r.querySelector('.tib-img-retry-overlay');
    if (ov) ov.remove();
  }

  function finish(img, broke) {
    img.removeAttribute('aria-busy');
    img.removeAttribute('data-tee-busy');
    if (img.dataset.teeAltBackup != null) {
      img.setAttribute('alt', img.dataset.teeAltBackup);
      delete img.dataset.teeAltBackup;
    }
    var orig = img.dataset.teeRetryOriginal || '';
    delete img.dataset.teeRetryOriginal;
    if (broke && orig) img.src = orig;
  }

  document.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!img || img.tagName.toLowerCase() !== 'img') return;
      if (img.classList.contains('tib-img-retry-spinner') ||
          img.getAttribute('data-tee-retry-spinner') === '1') return;
      if (img.getAttribute('data-tee-busy') === '1') return;

      var u = img.currentSrc || img.src || '';
      if (!u || u.indexOf('teeinblue') === -1 || u.indexOf('/common/loading.svg') !== -1) return;

      img.setAttribute('data-tee-busy', '1');

      var base = img.dataset.teeRetryOriginal || img.getAttribute('src') || u;
      if (!img.dataset.teeRetryOriginal) img.dataset.teeRetryOriginal = base;

      if (!img.dataset.teeAltBackup && img.getAttribute('alt')) {
        img.dataset.teeAltBackup = img.getAttribute('alt');
      }
      img.setAttribute('alt', '');
      img.setAttribute('aria-busy', 'true');
      overlayOn(wrap(img));

      sleep(DELAY).then(function () {
        (function pump(n) {
          if (n > MAX) { overlayOff(img); finish(img, true); return; }
          var cand = buildUrl(base, n);
          probeDecode(cand).then(function (ok) {
            if (ok) { img.src = cand; overlayOff(img); finish(img, false); return; }
            sleep(DELAY).then(function () { pump(n + 1); });
          });
        })(1);
      });
    },
    true
  );
})();
